const CLIENT_ADMIN_USER_TYPE_ID = 4;

type BillingAccessAccountInfo = {
  userTypeId?: number;
};

/**
 * Who may see the client billing page / entry point: account admins (owner,
 * userTypeId 4). Billing status is not a gate — an account without active
 * billing sees the page in its pre-activation state (DEV-10531).
 *
 * Mirrors the server-side gate in `assert-billing-access.ts`.
 */
export function canAccessClientBilling(
  accountInfo: BillingAccessAccountInfo | undefined | null,
): boolean {
  return accountInfo?.userTypeId === CLIENT_ADMIN_USER_TYPE_ID;
}
